/**
 * Home template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ThemeLogoMarquee from './lib/partials/ThemeLogoMarquee';
import ThemeImageAndNav from './lib/partials/ThemeImageAndNav';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Home';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initThemeLogoMarquees();
	initThemeImageAndNavs();
}

/**
 * initThemeLogoMarquees - Initialize the theme logo marquee
 * @returns
 */
const initThemeLogoMarquees = () => {
	Logger.info(`${NAME} > initThemeLogoMarquees`);
	const themeLogoMarquees = document.querySelectorAll('[data-theme-logo-marquee]');
	if (!themeLogoMarquees) return;
	themeLogoMarquees.forEach(themeLogoMarquee => {
		const el = new ThemeLogoMarquee(themeLogoMarquee);
		el.init();
	});
}

/**
 * initThemeImageAndNavs - Initialize the theme image and nav
 * @returns
 */
const initThemeImageAndNavs = () => {
	Logger.info(`${NAME} > initThemeImageAndNavs`);

	const themeImageAndNavs = document.querySelectorAll('[data-theme-image-and-nav]');
	if (!themeImageAndNavs) return;

	themeImageAndNavs.forEach(themeImageAndNav => {
		const el = new ThemeImageAndNav(themeImageAndNav);
		el.init();
	});
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
